import { CheckCircleIcon, XCircleIcon } from "../../images/icons/icons";
import { occupations } from "./PublicApis";
import moment from "moment-timezone";

export const today = moment.tz("Asia/Kolkata");
export const currentMonth = today.month() + 1;
export const currentYearNo = today.year();
const currentYear = new Date().getFullYear();

export const monthsData = [
  {
    value: "month",
    label: "Month",
  },
  {
    value: "year",
    label: "Year",
  },
  {
    value: "other",
    label: "Other",
  },
];

export const activityType = [
  {
    label: "All Activity",
    value: "all_activity",
  },
];

export const whatsapp_verification = [
  {
    label: "Required",
    value: "1",
  },
  {
    label: "Not Required",
    value: "0",
  },
];

export const weekdaysData = [
  {
    name: "Sunday",
    id: "sunday",
  },
  {
    name: "Monday",
    id: "monday",
  },
  {
    name: "Tuesday",
    id: "tuesday",
  },
  {
    name: "Wednesday",
    id: "wednesday",
  },
  {
    name: "Thursday",
    id: "thursday",
  },
  {
    name: "Friday",
    id: "friday",
  },
  {
    name: "Saturday",
    id: "saturday",
  },
];

export const planTypes = [
  // {
  //   value: "addon",
  //   label: "Addon",
  // },
  {
    value: "addon_pt",
    label: "PT",
  },
  {
    value: "regular",
    label: "Regular",
  },
];

export const paymentModes = [
  {
    value: "online",
    label: "Online",
  },
  {
    value: "cash",
    label: "Cash",
  },
  {
    value: "partial",
    label: "Partial Online/Cash",
  },
];

export const df_payment_modes = [
  {
    value: "online",
    label: "Online",
  },
  {
    value: "cash",
    label: "Cash",
  },
  {
    value: "dual",
    label: "Dual (Online + Cash)",
  },
  {
    value: "partial",
    label: "Partial (Installment)",
  },
];

export const upgrade_payment_modes = [
  {
    value: "online",
    label: "Online",
  },
  {
    value: "cash",
    label: "Cash",
  },
  {
    value: "dual",
    label: "Dual (Online + Cash)",
  },
];

export const trxModes = [
  // {
  //   value: "all",
  //   label: "All",
  // },
  {
    value: "online",
    label: "Online",
  },
  {
    value: "cash",
    label: "Cash",
  },
];

export const partialPaymentModes = [
  {
    value: "online",
    label: "Online",
  },
  {
    value: "cash",
    label: "Cash",
  },
];

export const extendSubscriptionDays = [
  {
    value: "15",
    label: "15",
  },
  {
    value: "30",
    label: "30",
  },
  {
    value: "45",
    label: "45",
  },
  {
    value: "60",
    label: "60",
  },
  {
    value: "90",
    label: "90",
  },
];

export const paymentStatus = [
  {
    value: "completed",
    label: "Completed",
  },
  {
    value: "pending",
    label: "Pending",
  },
  {
    value: "cash_approval_pending",
    label: "Cash Approval Pending",
  },
  {
    value: "cancelled",
    label: "Cancelled",
  },
];

export const paymentStatusCupon = [
  {
    value: "pending",
    label: "Pending",
  },
  {
    value: "approved",
    label: "Approved",
  },
  {
    value: "cancelled",
    label: "Cancelled",
  },
  {
    value: "removed",
    label: "Removed",
  },
];

export const discount_payments_approval_status = [
  {
    value: "pending",
    label: "Pending",
  },
  {
    value: "approved",
    label: "Approved",
  },
  {
    value: "cancelled",
    label: "Cancelled",
  },
  {
    value: "rejected",
    label: "Rejected",
  },
];

export const paymnetTypes = [
  {
    value: "1",
    label: "Partial",
  },
  {
    value: "0",
    label: "Full",
  },
];

export const approvalStatus = [
  {
    value: "1",
    label: "Approved",
  },
  {
    value: "-1",
    label: "Not Approved",
  },
  {
    value: "0",
    label: "Pending",
  },
  {
    value: "-2",
    label: "Cancelled/Resent",
  },
];

export const gender = [
  {
    value: "female",
    label: "♀ Female",
  },
  {
    value: "male",
    label: "♂ Male",
  },
  {
    value: "unspecified",
    label: "x Unspecified",
  },
  // {
  //   value: "other",
  //   label: "Other",
  // },
];

export const months = [
  { value: "1", label: "January" },
  { value: "2", label: "February" },
  { value: "3", label: "March" },
  { value: "4", label: "April" },
  { value: "5", label: "May" },
  { value: "6", label: "June" },
  { value: "7", label: "July" },
  { value: "8", label: "August" },
  { value: "9", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

export const years = Array.from({ length: currentYear - 2019 }, (_, index) => {
  const yearValue = currentYear - index;
  return { value: yearValue.toString(), label: yearValue.toString() };
});

export const yearsIncludingNext = Array.from(
  { length: currentYear - 2019 + 2 },
  (_, index) => {
    const yearValue = currentYear - index + 1;
    return { value: yearValue.toString(), label: yearValue.toString() };
  }
);

export const yearsPast100 = Array.from({ length: 101 }, (_, index) => {
  const yearValue = currentYear - index;
  return { value: yearValue.toString(), label: yearValue.toString() };
});

export const yearsNext = [
  { value: currentYear.toString(), label: currentYear.toString() },
  { value: (currentYear + 1).toString(), label: (currentYear + 1).toString() },
];

export const subscriptionTypes = [
  {
    value: "regular",
    label: "Regular",
  },
  {
    value: "addon",
    label: "Addon",
  },
  {
    value: "addon_pt",
    label: "Personal Training",
  },
  {
    value: "nutrition",
    label: "Nutrition",
  },
];

export const subscriptionTypes1 = [
  {
    value: "regular",
    label: "Regular",
  },
  {
    value: "addon",
    label: "Addon",
  },
  {
    value: "addon_pt",
    label: "Personal Training",
  },
  {
    value: "nutrition",
    label: "Nutrition",
  },
  {
    value: "one_day_membership",
    label: "One Day Membership",
  },
];

export const subscriptionDays = [
  {
    value: "30",
    label: "30",
  },
  {
    value: "60",
    label: "60",
  },
  {
    value: "90",
    label: "90",
  },
  {
    value: "180",
    label: "180",
  },
];

export const paymentModesSubs = [
  {
    value: "cash",
    label: "Cash",
  },
  {
    value: "online",
    label: "Online",
  },
  {
    value: "import_member",
    label: "Imported Member",
  },
  {
    value: "dual",
    label: "Dual (Online + Cash)",
  },
  {
    value: "partial",
    label: "Partial (Installment)",
  },
];

export const installmentModes = [
  { value: "cash", label: "Cash" },
  { value: "online", label: "Online" },
];

export const activeInactiveStatus = [
  {
    value: "active",
    label: "Active",
  },
  {
    value: "inactive",
    label: "Inactive",
  },
];

export const inventory_claim_status = [
  {
    value: "true",
    label: "Claim At Gym",
  },
  {
    value: "false",
    label: "Claim Online",
  },
];

export const approval_require = [
  {
    value: "1",
    label: "Approval Required",
  },
  {
    value: "0",
    label: "Approval Not Required",
  },
];

export const resolve_status = [
  {
    value: "1",
    label: "Resolved",
  },
  {
    value: "0",
    label: "Not Resolved",
  },
];

export const couple_plan_filter = [
  {
    value: "1",
    label: "Couple Plan",
  },
  {
    value: "0",
    label: "Non-Couple Plan",
  },
];

export const all_access_plan = [
  {
    value: "1",
    label: "All Gym Access Plan",
  },
  {
    value: "0",
    label: "Exclude - All Gym Access Plan",
  },
];

export const activeInactiveStatusNumeric = [
  {
    value: "1",
    label: "Active",
  },
  {
    value: "0",
    label: "Inactive",
  },
];

export const approve_reject_pending = [
  {
    value: "approved",
    label: "Approved",
  },
  {
    value: "rejected",
    label: "Rejected",
  },
  {
    value: "pending",
    label: "Pending",
  },
];

export const notify_statuses = [
  {
    value: "1",
    label: "On",
  },
  {
    value: "0",
    label: "Off",
  },
];

export const susbscriptionStatusBRM = [
  {
    value: "active",
    label: "Active",
  },
  {
    value: "expiring",
    label: "Expiring (Week)",
  },
];

export const conversion_status_boolean = [
  {
    value: "1",
    label: "Converted",
  },
  {
    value: "0",
    label: "Not Converted",
  },
];

export const susbscriptionStatus = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "active",
    label: "Active",
  },
  {
    value: "expiring",
    label: "Expiring (Week)",
  },
  {
    value: "expired",
    label: "Expired",
  },
  // {
  //   value: "draft",
  //   label: "Draft",
  // },
];

export const one_day_membership_status = [
  {
    value: "converted",
    label: "Converted",
  },
  {
    value: "not_converted",
    label: "Not Converted",
  },
  {
    value: "expiring",
    label: "Expiring",
  },
  {
    value: "expired",
    label: "Expired",
  },
];

export const mealCategories = [
  {
    value: "early_morning",
    label: "Early Morning",
  },
  {
    value: "mid_morning_snacks",
    label: "Mid Morning Snacks",
  },
  {
    value: "breakfast",
    label: "Breakfast",
  },
  {
    value: "lunch",
    label: "Lunch",
  },
  {
    value: "snacks",
    label: "Snacks",
  },
  {
    value: "dinner",
    label: "Dinner",
  },
  {
    value: "bed_time",
    label: "Bed Time",
  },
];

export const tvOptions = [
  {
    value: "1",
    label: "TV User",
  },
  {
    value: "0",
    label: "Not TV User",
  },
];

export const ratingOptions = [
  {
    value: 1,
    label: "1",
  },
  {
    value: 2,
    label: "2",
  },
  {
    value: 3,
    label: "3",
  },
  {
    value: 4,
    label: "4",
  },
  {
    value: 5,
    label: "5",
  },
];

export const popularities = [
  {
    value: "1",
    label: "Popular",
  },
  {
    value: "0",
    label: "Not Popular",
  },
];

export const days = [
  {
    value: "7",
    label: "1-7",
  },
  {
    value: "14",
    label: "1-14",
  },
  {
    value: "21",
    label: "1-21",
  },
];

export const memberGoals = [
  {
    value: "strength",
    label: "Strength",
  },
  {
    value: "muscle_size_gain",
    label: "Muscle Size / Gain",
  },
  {
    value: "muscle_endurance",
    label: "Muscle Endurance",
  },
  {
    value: "hiit",
    label: "HIIT",
  },
  {
    value: "fat_loss",
    label: "Fat Loss",
  },
  {
    value: "improve_lifestyle",
    label: "Improve Lifestyle",
  },
  {
    value: "general_itness",
    label: "General Fitness",
  },
  {
    value: "other",
    label: "Other",
  },
];

export const type_of_exercise = [
  {
    value: "strength",
    label: "Strength Training",
  },
  {
    value: "cardio",
    label: "Cardio (Running, Cycling, etc.)",
  },
  {
    value: "group_classes",
    label: "Group Classes",
  },
  {
    value: "other",
    label: "Other",
  },
];

export const pt_trial_focus = [
  {
    value: "fitness_assessment",
    label: "Fitness Assessment",
  },
  {
    value: "goal_setting",
    label: "Goal Setting",
  },
  {
    value: "workout_trial",
    label: "Workout Trial",
  },
  {
    value: "body_composition_analysis",
    label: "Body Composition Analysis",
  },
  {
    value: "other",
    label: "Other",
  },
];

export const memberBodyTypes = [
  {
    value: "skinny",
    label: "Skinny",
  },
  {
    value: "average",
    label: "Average",
  },
  {
    value: "athletic",
    label: "Athletic",
  },
  {
    value: "overWeight",
    label: "OverWeight",
  },
  {
    value: "heavy",
    label: "Heavy",
  },
];

export const memberActivityStatuses = [
  {
    value: "sedantry",
    label: "Sedantry",
  },
  {
    value: "light",
    label: "Light",
  },
  {
    value: "active",
    label: "Active",
  },
  {
    value: "very_active",
    label: "Very Active",
  },
  {
    value: "extra_active",
    label: "Extra Active",
  },
];

export const fitnessProfileActivityStatuses = [
  {
    value: "0",
    label: "Light",
  },
  {
    value: "1",
    label: "Moderate",
  },
  {
    value: "2",
    label: "Active",
  },
  {
    value: "3",
    label: "Very Active",
  },
  {
    value: "4",
    label: "Extra Active",
  },
];

export const dietPreferences = [
  {
    value: "vegetarian",
    label: "Vegetarian",
  },
  {
    value: "non_vegetarian",
    label: "Non Vegetarian",
  },
  {
    value: "eggetarian",
    label: "Eggetarian",
  },
];

export const ptTrialStatuses = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "pending",
    label: "All Pending",
  },
  {
    value: "completed",
    label: "All Completed (Not Converted)",
  },
  {
    value: "converted",
    label: "All Converted",
  },
  {
    value: "trial_done_cnvrtd",
    label: "PT Consultation Done And Converted",
  },
  {
    value: "trial_notdone_cnvrtd",
    label: "PT Consultation Not Done And Converted",
  },
  {
    value: "total_pending_today",
    label: "PT Consultation Pending Today",
  },
  {
    value: "total_completed_today",
    label: "PT Consultation Completed Today",
  },
];

export const handoverStatuses = [
  {
    value: "handover_all",
    label: "Total Handover",
  },
  {
    value: "handover_pending",
    label: "Pending Handover",
  },
  {
    value: "handover_completed",
    label: "Completed Handover",
  },
  {
    value: "handover_converted",
    label: "Converted Handover",
  },
];

export const languages = [
  {
    label: "English",
    value: "english",
  },
  {
    label: "Hindi",
    value: "hindi",
  },
  {
    label: "Bengali",
    value: "bengali",
  },
  {
    label: "Telugu",
    value: "telugu",
  },
  {
    label: "Marathi",
    value: "marathi",
  },
  {
    label: "Tamil",
    value: "tamil",
  },
  {
    label: "Urdu",
    value: "urdu",
  },
  {
    label: "Gujarati",
    value: "gujarati",
  },
  {
    label: "Kannada",
    value: "kannada",
  },
  {
    label: "Odia",
    value: "odia",
  },
  {
    label: "Malayalam",
    value: "malayalam",
  },
  {
    label: "Punjabi",
    value: "punjabi",
  },
  {
    label: "Assamese",
    value: "assamese",
  },
];

export const occupationsData = [
  ...occupations.map((occupation) => ({
    label: occupation.replace(/\b\w/g, (char) => char.toUpperCase()),
    value: occupation.toLowerCase().replace(/\s+/g, "_"),
  })),
  { label: "Other", value: "other" },
];

// export const occupationsData = occupations.map((occupation) => ({
//   label: occupation.replace(/\b\w/g, (char) => char.toUpperCase()),
//   value: occupation.toLowerCase().replace(/\s+/g, "_"),
// }));

export const dietCategories = [
  {
    value: "general",
    label: "General",
  },
  // {
  //   value: "custom",
  //   label: "Custom",
  // },
];

export const freePaidPlanTypes = [
  {
    value: "0",
    label: "Free",
  },
  {
    value: "1",
    label: "Paid",
  },
];

export const ptTrials = [
  {
    value: "1",
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <CheckCircleIcon /> Trial Assigned
      </span>
    ),
  },
  {
    value: "0",
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <XCircleIcon /> Trial Not Assigned
      </span>
    ),
  },
];

export const days_30 = Array.from({ length: 30 }, (_, index) => {
  return {
    value: index + 1,
    label: index + 1,
  };
});

export const daysAgo = Array.from({ length: 31 }, (_, index) => {
  if (index === 0) {
    return {
      value: "today",
      label: "Today",
    };
  } else {
    return {
      value: `${index}`,
      label: `${index} Day${index > 1 ? "s" : ""} Ago`,
    };
  }
});

export const withinDays = Array.from({ length: 31 }, (_, index) => {
  if (index === 0) {
    return {
      value: "today",
      label: "Today",
    };
  } else {
    return {
      value: `${index}`,
      label: `${index} Day${index > 1 ? "s" : ""}`,
    };
  }
});

export const daysAgoUptoYear = Array.from({ length: 366 }, (_, index) => {
  if (index === 0) {
    return {
      value: `${index}`,
      label: `${index} Day${index > 1 ? "s" : ""} Ago`,
      // value: "today",
      // label: "Today",
    };
  } else {
    return {
      value: `${index}`,
      label: `${index} Day${index > 1 ? "s" : ""} Ago`,
    };
  }
});

export const daysAfterUptoYear = Array.from({ length: 366 }, (_, index) => {
  if (index === 0) {
    return {
      value: `${index}`,
      label: `After ${index} Day${index > 1 ? "s" : ""}`,
      // value: "today",
      // label: "Today",
    };
  } else {
    return {
      value: `${index}`,
      label: `After ${index} Day${index > 1 ? "s" : ""}`,
    };
  }
});

export const biomaxStatus = [
  {
    value: "true",
    label: "Biomax Registered",
  },
  {
    value: "false",
    label: "Biomax Not Registered",
  },
];

export const tmeStatus = [
  {
    value: "added",
    label: "TME Added",
  },
  {
    value: "not_added",
    label: "TME Not Added",
  },
];

export const fitnessProfileStatus = [
  {
    value: "completed",
    label: "Fitness Profile Completed",
  },
  {
    value: "pending",
    label: "Fitness Profile Pending",
  },
];

export const trainer_rating = [
  {
    value: "done",
    label: "Done",
  },
  {
    value: "not_done",
    label: "Not Done",
  },
];

export const ratingStatus = [
  {
    value: "completed",
    label: "Rating Completed",
  },
  {
    value: "pending",
    label: "Rating Pending",
  },
];

export const dfPaymentStatus = [
  {
    value: "pending",
    label: "Pending",
  },
  {
    value: "completed",
    label: "Completed",
  },
  {
    value: "cancelled",
    label: "Cancelled",
  },
];

export const expense_statuses = [
  {
    value: "pending",
    label: "Approval Pending",
  },
  {
    value: "approved_notpaid",
    label: "Approved (Not Paid)",
  },
  {
    value: "approved_paid",
    label: "Approved/Paid",
  },
  {
    value: "rejected",
    label: "Rejected",
  },
  // {
  //   value: "rejected_by_acc",
  //   label: "Rejected By Accountant",
  // },
];

export const regularPlansDropdown = [
  {
    value: "30",
    label: "Monthly (30 Days)",
  },
  {
    value: "90",
    label: "Quarterly (90 Days)",
  },
  {
    value: "180",
    label: "Half Yearly (180 Days)",
  },
  {
    value: "365",
    label: "Yearly (365 Days)",
  },
];

export const leadPlanTypes = [
  {
    value: "monthly",
    label: "Monthly (30 Days)",
  },
  {
    value: "quaterly",
    label: "Quarterly (90 Days)",
  },
  {
    value: "half_yearly",
    label: "Half Yearly (180 Days)",
  },
  {
    value: "yearly",
    label: "Yearly (365 Days)",
  },
];

export const regularPlanDurationsDropdwon = [
  {
    value: "monthly",
    label: "Monthly (30 Days)",
  },
  {
    value: "quaterly",
    label: "Quarterly (90 Days)",
  },
  {
    value: "half_yearly",
    label: "Half Yearly (180 Days)",
  },
  {
    value: "yearly",
    label: "Yearly (365 Days)",
  },
  {
    value: "all",
    label: "All",
  },
];

export const campaignTypes = [
  {
    value: "1",
    label: "P2P",
  },
  {
    value: "2",
    label: "IVR",
  },
];

export const panelTypes = [
  {
    value: "panel_1",
    label: "Main",
  },
  {
    value: "panel_2",
    label: "IVR",
  },
];

export const leaveStatus = [
  {
    value: "0",
    label: "Pending",
  },
  {
    value: "1",
    label: "Approved",
  },
  {
    value: "2",
    label: "Rejected",
  },
];

export const monthlyYearlyLeaves = [
  {
    value: "yearly_stats",
    label: "Year",
  },
  {
    value: "category_sal_stats",
    label: "Month",
  },
];

export const staffRoles = [
  {
    value: "member",
    label: "Member",
  },
  {
    value: "trainer",
    label: "Trainer",
  },
  {
    value: "staff",
    label: "Sales Executive",
  },
  {
    value: "guest",
    label: "Guest",
  },
];

export const accountTypes = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "trainer",
    label: "Trainer",
  },
  {
    value: "receptionist",
    label: "Receptionist",
  },
  {
    value: "fitness_manager",
    label: "Fitness Manager",
  },
];

export const isPTProspectStatus = [
  {
    value: "1",
    label: "Prospect",
  },
  {
    value: "0",
    label: "Not Prospect",
  },
];

export const prospectStatus = [
  {
    value: "hot",
    label: "Hot Prospect",
  },
  {
    value: "semi_hot",
    label: "Semi Hot Prospect",
  },
  {
    value: "warm",
    label: "Warm Prospect",
  },
  {
    value: "cold",
    label: "Cold Prospect",
  },
  {
    value: "closed_cnvrtd",
    label: "Closed And Converted Prospect",
  },
  {
    value: "closed_not_cnvrtd",
    label: "Closed And Not Converted Prospect",
  },
  {
    value: "not_specified_prspct",
    label: "Prospect Not Specified",
  },
];

const formatTime = (hour) => (hour < 10 ? `0${hour}` : hour) + ":00";
export const timeSlots = [];
for (let hour = 5; hour <= 23; hour++) {
  const labelHour = hour % 12 || 12;
  const amPm = hour < 12 ? "AM" : "PM";

  let nextHour, nextAmPm;
  if (hour === 23) {
    nextHour = 12;
    nextAmPm = "AM";
  } else {
    nextHour = (hour + 1) % 12 || 12;
    nextAmPm = hour + 1 < 12 ? "AM" : "PM";
  }

  const label = `${labelHour} ${amPm} - ${nextHour} ${nextAmPm}`;
  const value = `${formatTime(hour)}-${formatTime(hour + 1)}`;

  timeSlots.push({ value, label });
}

export const timeSlotsQuarter = [];
const quarters = [
  { start: 6, end: 9, label: "Q1" },
  { start: 9, end: 12, label: "Q2" },
  { start: 12, end: 15, label: "Q3" },
  { start: 15, end: 18, label: "Q4" },
  { start: 18, end: 22, label: "Q5" },
];
quarters.forEach((quarter) => {
  const { start, end, label } = quarter;
  const formattedStart = formatTime(start);
  const formattedEnd = formatTime(end);
  const value = `${formattedStart}-${formattedEnd}`;
  const labelText = `${label} (${start % 12 || 12} ${
    start < 12 ? "AM" : "PM"
  } - ${end % 12 || 12} ${end < 12 ? "AM" : "PM"})`;

  timeSlotsQuarter.push({ value, label: labelText });
});

export const times = [
  {
    label: "5:00 am",
    value: "05:00",
  },
  {
    label: "5:30 am",
    value: "05:30",
  },
  {
    label: "6:00 am",
    value: "06:00",
  },
  {
    label: "6:30 am",
    value: "06:30",
  },
  {
    label: "7:00 am",
    value: "07:00",
  },
  {
    label: "7:30 am",
    value: "07:30",
  },
  {
    label: "8:00 am",
    value: "08:00",
  },
  {
    label: "8:30 am",
    value: "08:30",
  },
  {
    label: "9:00 am",
    value: "09:00",
  },
  {
    label: "9:30 am",
    value: "09:30",
  },
  {
    label: "10:00 am",
    value: "10:00",
  },
  {
    label: "10:30 am",
    value: "10:30",
  },
  {
    label: "11:00 am",
    value: "11:00",
  },
  {
    label: "11:30 am",
    value: "11:30",
  },
  {
    label: "12:00 pm",
    value: "12:00",
  },
  {
    label: "12:30 pm",
    value: "12:30",
  },
  {
    label: "1:00 pm",
    value: "13:00",
  },
  {
    label: "1:30 pm",
    value: "13:30",
  },
  {
    label: "2:00 pm",
    value: "14:00",
  },
  {
    label: "2:30 pm",
    value: "14:30",
  },
  {
    label: "3:00 pm",
    value: "15:00",
  },
  {
    label: "3:30 pm",
    value: "15:30",
  },
  {
    label: "4:00 pm",
    value: "16:00",
  },
  {
    label: "4:30 pm",
    value: "16:30",
  },
  {
    label: "5:00 pm",
    value: "17:00",
  },
  {
    label: "5:30 pm",
    value: "17:30",
  },
  {
    label: "6:00 pm",
    value: "18:00",
  },
  {
    label: "6:30 pm",
    value: "18:30",
  },
  {
    label: "7:00 pm",
    value: "19:00",
  },
  {
    label: "7:30 pm",
    value: "19:30",
  },
  {
    label: "8:00 pm",
    value: "20:00",
  },
  {
    label: "8:30 pm",
    value: "20:30",
  },
  {
    label: "9:00 pm",
    value: "21:00",
  },
  {
    label: "9:30 pm",
    value: "21:30",
  },
  {
    label: "10:00 pm",
    value: "22:00",
  },
  {
    label: "10:30 pm",
    value: "22:30",
  },
  {
    label: "11:00 pm",
    value: "23:00",
  },
  {
    label: "11:30 pm",
    value: "23:30",
  },
];

export const generateTimeOptions = () => {
  const options = [];

  for (let i = 10; i <= 11; i++) {
    options.push({ label: `${i}:00 am`, value: `${i}:00` });
    options.push({ label: `${i}:30 am`, value: `${i}:30` });
  }

  options.push({ label: `12:00 pm`, value: `12:00` });
  options.push({ label: `12:30 pm`, value: `12:30` });

  for (let j = 1; j <= 9; j++) {
    options.push({ label: `${j}:00 pm`, value: `${j + 12}:00` });
    options.push({ label: `${j}:30 pm`, value: `${j + 12}:30` });
  }

  return options;
};

export const getCurrentTimeOption = () => {
  const now = moment.tz("Asia/Kolkata");
  const hours = now.hours();
  const minutes = now.minutes().toString().padStart(2, "0");
  const period = hours >= 12 ? "pm" : "am";

  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
  const label = `${formattedHours}:${minutes} ${period}`;
  const value = `${hours}:${minutes}`;

  return [{ label, value }];
};

export const leadSources = [
  {
    value: "company_leads",
    label: "Company Lead",
  },
  {
    value: "cold_calling",
    label: "Cold Calling",
  },
  {
    value: "referral",
    label: "Refferral",
  },
  {
    value: "gym_visit",
    label: "Physical Gym Visit",
  },
  {
    value: "ivr",
    label: "IVR",
  },
  {
    value: "renewal",
    label: "Renewal",
  },
  {
    value: "wati",
    label: "Wati",
  },
  {
    value: "trial",
    label: "Trial",
  },
];

export const rawLeadeadSources = [
  {
    value: "wati",
    label: "Wati",
  },
  {
    value: "trial",
    label: "Trial",
  },
];

export const UTMSources = [
  {
    value: "facebook",
    label: "Facebook",
  },
  {
    value: "google",
    label: "Google",
  },
  {
    value: "organic",
    label: "Organic",
  },
];

export const shift_statuses = [
  {
    value: "on_time",
    label: "On Time",
  },
  {
    value: "early",
    label: "Early",
  },
  {
    value: "late",
    label: "Late",
  },
  {
    value: "absent",
    label: "Absent",
  },
  {
    value: "day_off",
    label: "Day Off",
  },
  {
    value: "on_leave",
    label: "On Leave",
  },
  {
    value: "upcoming",
    label: "Upcoming",
  },
  {
    value: "checked-in",
    label: "Checked-in",
  },
  {
    value: "checked-out",
    label: "Checked-out",
  },
  {
    value: "checkout-missed",
    label: "Checkout Missed",
  },
  {
    value: "checkout-upcoming",
    label: "Checkout Upcoming",
  },
];

export const halfday_late_checkin_statuses = [
  {
    value: "true",
    label: "Half Day",
  },
  {
    value: "false",
    label: "Late Checkin",
  },
];

export const paymentSources = [
  {
    value: "app",
    label: "App",
  },
  {
    value: "link",
    label: "Link",
  },
];

export const payment_sources = [
  {
    value: "app",
    label: "App",
  },
  {
    value: "website",
    label: "Website",
  },
];

export const leadCustomerCategories = [
  {
    value: "hot",
    label: "Hot Lead (Same Day)",
  },
  {
    value: "semi_hot",
    label: "Semi Hot (Next Day)",
  },
  {
    value: "warm",
    label: "Warm (3rd Day)",
  },
  {
    value: "cold",
    label: "Cold (More Than 3 Days)",
  },
  {
    value: "not_updated",
    label: "Status Not Updated",
  },
];

export const leadFollowupStatuses = [
  {
    value: "dnp",
    label: "Did Not Picked Up",
  },
  {
    value: "walk_in",
    label: "Walk-in",
  },
  {
    value: "reschedule",
    label: "Reschedule",
  },
  {
    value: "switched_off",
    label: "Switched-off",
  },
  {
    value: "distance_issue",
    label: "Distance Issue",
  },
  {
    value: "renewal",
    label: "Renewal",
  },
  {
    value: "other",
    label: "Other",
  },
];

export const referral_statuses = [
  {
    value: "converted",
    label: "Converted",
  },
  {
    value: "pending",
    label: "Pending",
  },
];

export const leadClosingOPeningStatuses = [
  {
    value: "converted",
    label: "Converted",
  },
  {
    value: "closed",
    label: "Closed",
  },
  {
    value: "pending",
    label: "Pending Follow-up",
  },
];

export const leadFollowupStages = Array.from({ length: 30 }, (_, index) => {
  const value = (index + 1).toString();
  return { value, label: value };
});

export const randomCountUpto100 = Array.from({ length: 100 }, (_, index) => {
  const value = (index + 1).toString();
  return { value, label: value };
});

export const pendingCompletedStatus = [
  {
    value: "pending",
    label: "Trainer Intro Pending",
  },
  {
    value: "completed",
    label: "Trainer Intro Completed",
  },
];

export const callInitiatedStatuses = [
  {
    value: "connected",
    label: "Connected",
  },
  {
    value: "missed",
    label: "Missed",
  },
  {
    value: "Connected Agent Missed",
    label: "Connected Agent Missed",
  },
  {
    value: "connected_user_missed",
    label: "Connected User Missed",
  },
  {
    value: "total_call",
    label: "Total Call",
  },
];

export const leadCloseStatus = [
  {
    value: "closed",
    label: "Close",
  },
  // {
  //   value: "converted",
  //   label: "Converted",
  // },
];

export const ages = Array.from({ length: 91 }, (_, index) => {
  const value = 10 + index;
  return {
    value: value,
    label: value,
  };
});

export const smallRangeDataUpto8 = Array.from({ length: 8 }, (_, index) => {
  const value = 1 + index;
  return {
    value: value,
    label: value,
  };
});

export const smallRangeDataUpto11 = Array.from({ length: 11 }, (_, index) => {
  const value = 0 + index;
  return {
    value: value,
    label: value,
  };
});

export const rangeDataUpto285 = Array.from({ length: 285 }, (_, index) => {
  const value = 1 + index;
  return {
    value: value,
    label: value,
  };
});

export const medicalIssues = [
  {
    value: "diabetes",
    label: "Diabetes",
  },
  {
    value: "cholesterol",
    label: "Cholesterol",
  },
  {
    value: "pcos",
    label: "PCOS",
  },
  {
    value: "hypertension",
    label: "Hypertension",
  },
  {
    value: "thyroid",
    label: "Thyroid",
  },
  {
    value: "physical_injury",
    label: "Physical Injury",
  },
  {
    value: "stress",
    label: "Excessive Stress/Anxiety",
  },
  {
    value: "depression",
    label: "Depression",
  },
  {
    value: "anger_issues",
    label: "Anger Issues",
  },
  {
    value: "other",
    label: "Other",
  },
];

export function generatePlanDuration(planDuration) {
  const array = [];
  for (let i = 1; i <= planDuration; i++) {
    array.push({ label: i, value: i });
  }
  return array;
}

export function generatePlanDuration1(planDuration) {
  const array = [];
  for (let i = 1; i <= planDuration; i++) {
    array.push({ label: `${i} Day`, value: i });
  }
  return array;
}

export const fileTypes = [
  {
    value: "link",
    label: "Link",
  },
  {
    value: "upload",
    label: "Upload",
  },
];

export const movementTypes = [
  {
    value: "unilateral",
    label: "Isolation",
  },
  {
    value: "compound",
    label: "Compound",
  },
];

export const workoutPackageSuitableFor = [
  {
    value: "beginner",
    label: "Beginner",
  },
  {
    value: "intermediate",
    label: "Intermediate",
  },
  {
    value: "advanced",
    label: "Advanced",
  },
];

export const fitness_experiences = [
  {
    value: "beginner",
    label:
      "Beginner (1-3 months or resuming after a long gap of minimum 3 months)",
  },
  {
    value: "intermediate",
    label: "Intermediate (4 - 12 months)",
  },
  {
    value: "advanced",
    label: "Advanced (Above 12 months)",
  },
];

export const experiences_per_week = [
  {
    value: "1_2_times",
    label: "1-2 times",
  },
  {
    value: "3_4_times",
    label: "3-4 times",
  },
  {
    value: "5_6_times",
    label: "5-6 times",
  },
  {
    value: "7_times_or_more",
    label: "7 times or more",
  },
];

export const workoutPackagePlanTypes = [
  {
    value: "strength",
    label: "Strength",
  },
  {
    value: "endurance",
    label: "Endurance",
  },
];

export const workoutPackagePlanCategories = [
  {
    value: "home",
    label: "Home",
  },
  {
    value: "gym",
    label: "At Gym",
  },
];

export const workoutPackagePlanAccess = [
  {
    value: "user",
    label: "User",
  },
  {
    value: "member",
    label: "Subscribed Member",
  },
  {
    value: "both",
    label: "Both",
  },
];

export const setTypes = [
  {
    value: "superset",
    label: "Superset",
  },
  {
    value: "singular",
    label: "Singular",
  },
];

export const testimonialCategories = [
  {
    value: "vibe",
    label: "Vibe",
  },
  {
    value: "testimonial",
    label: "Testimonial",
  },
];

export const testimonialMediaType = [
  {
    value: "image",
    label: "Image",
  },
  {
    value: "video",
    label: "Video",
  },
];

export const recurringStatus = [
  {
    value: "true",
    label: "Recurring",
  },
  {
    value: "false",
    label: "Non Recurring",
  },
];

export const completed_pending = [
  {
    value: "0",
    label: "Pending",
  },
  {
    value: "1",
    label: "Completed",
  },
];

export const biomaxAppRegisterStatus = [
  {
    value: "pending",
    label: "Pending",
  },
  {
    value: "completed",
    label: "Completed",
  },
];

export const HHMMSS = Array.from({ length: 60 }, (_, i) => {
  const value = i.toString().padStart(2, "0");
  return {
    value: value,
    label: value,
  };
});

export const workoutModes = [
  {
    value: "time_based",
    label: "Time Based",
  },
  {
    value: "rep_based",
    label: "Rep Based",
  },
];

export const RPTypes = [
  {
    value: "pt",
    label: "PT",
  },
  {
    value: "regular",
    label: "Regular",
  },
  {
    value: "overall",
    label: "Overall",
  },
  // {
  //   value: "all",
  //   label: "All",
  // },
];

export const hygieneTaskIntervals = [
  {
    value: "hour",
    label: "Hourly",
  },
  {
    value: "day",
    label: "Daily",
  },
  {
    value: "week",
    label: "Weekly",
  },
  {
    value: "month",
    label: "Monthly",
  },
  {
    value: "year",
    label: "Yearly",
  },
];

export const hygieneMeadiaTypes = [
  {
    value: "image",
    label: "Image",
  },
  {
    value: "video",
    label: "Video",
  },
  {
    value: "both",
    label: "Both",
  },
];

export const hygieneAsignee = [
  {
    value: "receptionist",
    label: "Receptionist",
  },
  {
    value: "trainer",
    label: "Trainer",
  },
];

export const trainer_receptionist_both = [
  {
    value: "receptionist",
    label: "Receptionist",
  },
  {
    value: "trainer",
    label: "Trainer",
  },
  {
    value: "both",
    label: "Both",
  },
];

export const url_video = [
  {
    value: "url",
    label: "URL",
  },
  {
    value: "video",
    label: "Video",
  },
];

export const raw_lead_from = [
  {
    value: "1",
    label: "From Raw Lead",
  },
  {
    value: "0",
    label: "Not From Raw Lead",
  },
];

export const leadFrom = [
  {
    value: "raw_lead",
    label: "Raw Lead",
  },
  {
    value: "renewal",
    label: "Renewal",
  },
  {
    value: "unpaid",
    label: "Unpaid",
  },
  {
    value: "lms",
    label: "LMS",
  },
];

export const dayNames = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const daysOfWeek = dayNames.map((day) => ({
  label: day,
  value: day.toLowerCase(),
}));

export const offerModes = [
  {
    value: "one_time",
    label: "One Time",
  },
  {
    value: "recurring",
    label: "Recurring",
  },
];

export const offerTypes = [
  {
    value: "flat",
    label: "Flat",
  },
  {
    value: "percentage",
    label: "Percentage",
  },
];

export const renewalFromCurrent = [
  {
    value: "same_day_renewal",
    label: "Same Day Renewal",
  },
  {
    value: "other_day_renewal",
    label: "Other Day Renewal",
  },
];

export const renewalFromPast = [
  {
    value: "same_month",
    label: "Same Month",
  },
  {
    value: "other_month",
    label: "Other Month",
  },
];

export const paginationLimits1 = Array.from({ length: 20 }, (_, i) => {
  const value = (i + 1) * 10;
  return {
    value: value.toString(),
    label: value.toString(),
  };
});

export const paginationLimits = [
  { value: "5", label: "5" },
  ...Array.from({ length: 20 }, (_, i) => {
    const value = (i + 1) * 10;
    return {
      value: value.toString(),
      label: value.toString(),
    };
  }),
];

export const pt_plan_status = [
  {
    value: "active",
    label: "Active",
  },
  {
    value: "expired",
    label: "Expired",
  },
  {
    value: "not_subscribed",
    label: "Not Subscribed",
  },
];

export const subscription_status = [
  {
    value: "active",
    label: "Active",
  },
  {
    value: "expired",
    label: "Expired",
  },
];

export const lead_btn_enable = [
  {
    value: "1",
    label: "Lead Creation Enabled",
  },
  {
    value: "0",
    label: "Lead Creation Disabled",
  },
];

export const added_not_added_to_lead = [
  {
    value: "true",
    label: "Added To Lead",
  },
  {
    value: "false",
    label: "Not Added To Lead",
  },
];

export const added_not_added_to_lead_boolean = [
  {
    value: "1",
    label: "Added To LMS",
  },
  {
    value: "0",
    label: "Not Added To LMS",
  },
];

export const ODM_STATUS = [
  {
    value: "1",
    label: "ODM Purchased",
  },
  {
    value: "0",
    label: "ODM Not Purchased",
  },
];

export const recusrring_status = [
  {
    value: "1",
    label: "999 Purchased",
  },
  {
    value: "0",
    label: "999 Not Purchased",
  },
];

export const pt_interest = [
  {
    value: "1",
    label: "Interested",
  },
  {
    value: "0",
    label: "Not Interested",
  },
];

export const trial_added_from = [
  {
    value: "engagement",
    label: "Added From TME(Trainer Member Engagement) Form",
  },
  {
    value: "direct",
    label: "Direct (PT Track System)",
  },
  {
    value: "app",
    label: "App",
  },
];

export const staff_types = [
  {
    label: "Trainer",
    value: "trainer",
  },
  {
    label: "Receptionist",
    value: "receptionist",
  },
];

export const all_account_types = [
  {
    label: "Admin",
    value: "admin",
  },
  {
    label: "Trainer",
    value: "trainer",
  },
  {
    label: "Receptionist",
    value: "receptionist",
  },
  {
    label: "Cluster Manager",
    value: "cluster_manager",
  },
  {
    label: "Nutrition",
    value: "nutrition",
  },
  {
    label: "Sales",
    value: "sales",
  },
  {
    label: "Fitness Manager",
    value: "fitness_manager",
  },
  {
    label: "Sales Manager",
    value: "sales_manager",
  },
  {
    label: "Marketing",
    value: "marketing",
  },
];

export const account_types = [
  {
    label: "Trainer",
    value: "trainer",
  },
  {
    label: "Receptionist",
    value: "receptionist",
  },
  {
    label: "Admin",
    value: "admin",
  },
  {
    label: "Gym",
    value: "gym",
  },
  {
    label: "Nutrition",
    value: "nutrition",
  },
  {
    label: "Staff",
    value: "staff",
  },
  {
    label: "Sales",
    value: "sales",
  },
  {
    label: "Cash Collector",
    value: "cash_collector",
  },
  {
    label: "Fitness Manager",
    value: "fitness_manager",
  },
  {
    label: "Sales Manager",
    value: "sales_manager",
  },
  {
    label: "Marketing",
    value: "marketing",
  },
];

export const onboarding_staff_types = [
  {
    label: "Trainer",
    value: "trainer",
  },
  {
    label: "Receptionist",
    value: "receptionist",
  },
  {
    label: "Cluster Manager",
    value: "cluster_manager",
  },
  {
    label: "Fitness Manager",
    value: "fitness_manager",
  },
  {
    label: "Sales Manager",
    value: "sales_manager",
  },
  {
    label: "Club Manager",
    value: "club_manager",
  },
  {
    label: "Marketing",
    value: "marketing",
  },
];

export const shift_types = [
  { value: "morning", label: "Morning" },
  { value: "evening", label: "Evening" },
];

export const shift_timings = [
  {
    value: "05:00 - 12:00",
    label: "5am - 12pm",
  },
  {
    value: "12:00 - 17:00",
    label: "12pm - 5pm",
  },
  {
    value: "17:00 - 22:00",
    label: "5pm - 10pm",
  },
];

export const slot_times = [
  {
    value: "05:00 - 06:00",
    label: "5am - 6am",
  },
  {
    value: "06:00 - 07:00",
    label: "6am - 7am",
  },
  {
    value: "07:00 - 08:00",
    label: "7am - 8am",
  },
  {
    value: "08:00 - 09:00",
    label: "8am - 9am",
  },
  {
    value: "09:00 - 10:00",
    label: "9am - 10am",
  },
  {
    value: "10:00 - 11:00",
    label: "10am - 11am",
  },
  {
    value: "11:00 - 12:00",
    label: "11am - 12pm",
  },
  {
    value: "12:00 - 13:00",
    label: "12pm - 1pm",
  },
  {
    value: "13:00 - 14:00",
    label: "1pm - 2pm",
  },
  {
    value: "14:00 - 15:00",
    label: "2pm - 3pm",
  },
  {
    value: "15:00 - 16:00",
    label: "3pm - 4pm",
  },
  {
    value: "16:00 - 17:00",
    label: "4pm - 5pm",
  },
  {
    value: "17:00 - 18:00",
    label: "5pm - 6pm",
  },
  {
    value: "18:00 - 19:00",
    label: "6pm - 7pm",
  },
  {
    value: "19:00 - 20:00",
    label: "7pm - 8pm",
  },
  {
    value: "20:00 - 21:00",
    label: "8pm - 9pm",
  },
  {
    value: "21:00 - 22:00",
    label: "9pm - 10pm",
  },
];

export const generateShiftTimings = (startHour, endHour) => {
  const shiftTimings = [];
  for (let hour = startHour; hour < endHour; hour++) {
    const nextHour = hour + 1;

    const value = `${hour.toString().padStart(2, "0")}:00-${nextHour
      .toString()
      .padStart(2, "0")}:00`;
    const label = `${formatHour12(hour)} - ${formatHour12(nextHour)}`;

    shiftTimings.push({
      value: value.replace(/\s/g, ""),
      label,
    });
  }
  return shiftTimings;
};

const formatHour12 = (hour) => {
  const period = hour < 12 ? "am" : "pm";
  const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
  return `${formattedHour}${period}`;
};

export const slot_times_dynamic = generateShiftTimings(5, 22);

export const days_upto_30 = Array.from({ length: 30 }, (_, i) => {
  const dayCount = i + 1;
  return {
    value: dayCount,
    label: `${dayCount} ${dayCount === 1 ? "day" : "days"}`,
  };
});

export const hours_upto_24 = Array.from({ length: 24 }, (_, i) => {
  const hourCount = i + 1;
  return {
    value: hourCount,
    label: `${hourCount} hour`,
  };
});

export const mins_upto_60 = Array.from({ length: 60 }, (_, i) => {
  const minCount = i + 1;
  return {
    value: minCount,
    label: `${minCount} ${minCount === 1 ? "min" : "mins"}`,
  };
});

export const expense_types = [
  {
    value: "gym",
    label: "Gym",
  },
  {
    value: "wtf",
    label: "WTF",
  },
];

export const expense_payment_options = [
  {
    value: "qr",
    label: "QR (max ₹2000)",
  },
  {
    value: "upi",
    label: "UPI",
  },
  {
    value: "bank",
    label: "Bank Account",
  },
];

export const expense_payee_options = [
  {
    value: "self",
    label: "Self",
  },
  {
    value: "vendor",
    label: "Vendor",
  },
];

export const image_pdf = [
  {
    value: "image",
    label: "Image",
  },
  {
    value: "pdf",
    label: "PDF",
  },
];

export const hygine_task_frequency_categories = [
  { value: "no_repeat", label: "No Repeat" },
  {
    value: "daily",
    label: "Daily",
  },
  {
    value: "hourly",
    label: "Hourly",
  },
  {
    value: "weekly",
    label: "Weekly",
  },
  {
    value: "monthly",
    label: "Monthly",
  },
  {
    value: "yearly",
    label: "Yearly",
  },
  { value: "week_days", label: "Weekdays" },
  { value: "weekend", label: "Weekend" },
  { value: "custom", label: "Custom" },
];

export const generateNumberObjects = () => {
  return Array.from({ length: 12 }, (_, index) => {
    const number = index + 1;
    return {
      label: number.toString(),
      value: number,
    };
  });
};

export const TASK_PRIORITY = [
  {
    value: "critical",
    label: (
      <span>
        <span
          className="badge"
          style={{
            backgroundColor: "#dc3545",
            color: "white",
            padding: "4px 8px",
            borderRadius: "4px",
          }}
        >
          P1
        </span>{" "}
        - Critical
      </span>
    ),
  },
  {
    value: "high",
    label: (
      <span>
        <span
          className="badge"
          style={{
            backgroundColor: "#ffc107",
            color: "black",
            padding: "4px 8px",
            borderRadius: "4px",
          }}
        >
          P2
        </span>{" "}
        - High
      </span>
    ),
  },
  {
    value: "medium",
    label: (
      <span>
        <span
          className="badge"
          style={{
            backgroundColor: "#0d6efd",
            color: "white",
            padding: "4px 8px",
            borderRadius: "4px",
          }}
        >
          P3
        </span>{" "}
        - Medium
      </span>
    ),
  },
  {
    value: "low",
    label: (
      <span>
        <span
          className="badge"
          style={{
            backgroundColor: "#198754",
            color: "white",
            padding: "4px 8px",
            borderRadius: "4px",
          }}
        >
          P4
        </span>{" "}
        - Low
      </span>
    ),
  },
];

export const PT_TRIAL_RUN_TEST = [
  {
    value: "poor",
    label: "Poor (<150m)",
  },
  {
    value: "average",
    label: "Average (150-200m)",
  },
  {
    value: "good",
    label: "Good (200-250m)",
  },
  {
    value: "excellent",
    label: "Excellent (>250m)",
  },
];

export const PT_TRIAL_PUSHUP_TEST = [
  {
    value: "poor",
    label: "Poor (<10)",
  },
  {
    value: "average",
    label: "Average (10-20)",
  },
  {
    value: "good",
    label: "Good (20-30)",
  },
  {
    value: "excellent",
    label: "Excellent (>35)",
  },
];

export const PT_TRIAL_PLANK_TEST = [
  {
    value: "poor",
    label: "Poor (<30s)",
  },
  {
    value: "average",
    label: "Average (30-60s)",
  },
  {
    value: "good",
    label: "Good (60-90s)",
  },
  {
    value: "excellent",
    label: "Excellent (>90s)",
  },
];

export const PT_TRIAL_INLINE_LUNGE__TEST = [
  {
    value: "poor",
    label: "Poor (Unable to maintain position or requires support.)",
  },
  {
    value: "average",
    label: "Average (Slight instability but able to complete.)",
  },
  {
    value: "good",
    label: "Good (Maintains balance, minimal wobbbling.)",
  },
];

export const PT_TRIAL_SHOULDER_FLEXION_TEST = [
  {
    value: "poor",
    label: "Poor (Arms far from overhead.)",
  },
  {
    value: "average",
    label: "Average (Arms at an angle but not overhead.)",
  },
  {
    value: "good",
    label: "Good (Arms reach ears.)",
  },
];

export const PT_TRIAL_SHOULDER_EXTENSION_TEST = [
  {
    value: "poor",
    label: "Poor (Minimal extension.)",
  },
  {
    value: "average",
    label: "Average (Moderate reach behind.)",
  },
  {
    value: "good",
    label: "Good (Hands reach behind back easily.)",
  },
];

export const PT_TRIAL_LEG_RAISE_TEST = [
  {
    value: "poor",
    label: "Poor (<60°)",
  },
  {
    value: "average",
    label: "Average (60-80°)",
  },
  {
    value: "good",
    label: "Good (80-90°)",
  },
];

export const PT_TRIAL_THOMAS_TEST = [
  {
    value: "poor",
    label: "Poor (Significant elevation.)",
  },
  {
    value: "average",
    label: "Average (Thigh slightly elevated.)",
  },
  {
    value: "good",
    label: "Good (Thigh of extended leg stays flat.)",
  },
];

export const PT_TRIAL_OVERALL_FITNESS_RATING = [
  {
    value: "poor",
    label: "Needs Improvement (Majority of tests in Poor range.)",
  },
  {
    value: "average",
    label: "Average (Mixed performance with some Average and Poor ratings.)",
  },
  {
    value: "good",
    label: "Good (Majority of tests in Good range.)",
  },
  {
    value: "excellent",
    label: "Excellent (All or most tests in the Excellent range)",
  },
];

export const TASK_APPROVAL_STATUS = [
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "In Progress",
    value: "in_progress",
  },
  {
    label: "Completed",
    value: "completed",
  },
];

export const ONBOARDING_STATUS = [
  {
    label: "Pending",
    value: "0",
  },
  {
    label: "Rejected",
    value: "-1",
  },
  {
    label: "Approved",
    value: "1",
  },
];

export const pt_revenue_view_type = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "full",
    label: "Full",
  },
  {
    value: "partial",
    label: "Partial",
  },
  {
    value: "past_partial",
    label: "Past Partial",
  },
];

export const transfer_type = [
  {
    value: "gym",
    label: "Gym Transfer",
  },
  {
    value: "subscription",
    label: "Membership Transfer",
  },
];

export const pause_status = [
  {
    value: "true",
    label: "Active Pause",
  },
  {
    value: "false",
    label: "Inactive Pause",
  },
];

export const renewal_unpaid = [
  {
    value: "renewal",
    label: "Renewal",
  },
  {
    value: "unpaid",
    label: "Unpaid",
  },
];

export const trigger_type = [
  {
    value: "trigger",
    label: "Trigger",
  },
  {
    value: "general",
    label: "General",
  },
];

export const template_categories = [
  {
    value: "MARKETING",
    label: "MARKETING",
  },
  {
    value: "UTILITY",
    label: "UTILITY",
  },
];

export const variable_types = [
  {
    value: "key",
    label: "Key",
  },
  {
    value: "static",
    label: "Static",
  },
];

export const wp_template_status = [
  {
    label: "PENDING",
    value: "PENDING",
  },
  {
    label: "REJECTED",
    value: "REJECTED",
  },
  {
    label: "APPROVED",
    value: "APPROVED",
  },
];

export const broadcast_variable = [
  {
    label: "Name",
    value: "name",
  },
  {
    label: "Email",
    value: "email",
  },
  {
    label: "Mobile",
    value: "mobile",
  },
  {
    label: "Gym ID",
    value: "gym_id",
  },
  {
    label: "Gym Name",
    value: "gym_name",
  },
  {
    label: "Current Plan",
    value: "current_plan",
  },
  {
    label: "Current Plan Status",
    value: "current_plan_status",
  },
  {
    label: "Receptionist One Name",
    value: "receptionist_one_name",
  },
  {
    label: "Receptionist One Mobile",
    value: "receptionist_one_mobile",
  },
  {
    label: "Receptionist Two Name",
    value: "receptionist_two_name",
  },
  {
    label: "Receptionist Two Mobile",
    value: "receptionist_two_mobile",
  },
];

export const recipient_roles = [
  {
    value: "member",
    label: "Member",
  },
  {
    value: "trainer",
    label: "Trainer",
  },
  {
    value: "receptionist",
    label: "Receptionist",
  },
  {
    value: "cluster_manager",
    label: "Cluster Manager",
  },
];

export const custom_types = [
  {
    value: "member",
    label: "Member (All Members)",
  },
  {
    value: "lead",
    label: "Lead (All Follow-up Leads)",
  },
];

export const experience_level = [
  {
    value: "beginner",
    label: "Beginner",
  },
  {
    value: "intermediate",
    label: "Intermediate",
  },
  {
    value: "advanced",
    label: "Advanced",
  },
];

export const payment_location = [
  {
    value: "gym",
    label: "Inside Gym",
  },
  {
    value: "outside",
    label: "Outside Gym",
  },
];

export const broadcast_channel = [
  {
    value: "whatsapp",
    label: "Whatsapp",
  },
  {
    value: "email",
    label: "Email",
  },
  {
    value: "push",
    label: "Push",
  },
];

export const submission_type = [
  {
    value: "qr",
    label: "QR",
  },
  {
    value: "staff",
    label: "Staff",
  },
];

export const bca_status = [
  {
    value: "completed",
    label: "Completed",
  },
  {
    value: "pending",
    label: "Pending",
  },
  {
    value: "upcoming",
    label: "Upcoming",
  },
  {
    value: "missed",
    label: "Missed",
  },
];

export const bca_status_tme = [
  {
    value: "done",
    label: "First BCA Done",
  },
  {
    value: "not_done",
    label: "First BCA Pending",
  },
];

export const broadcast_page_name = [
  {
    value: "lms",
    label: "LMS",
    url: "/leads/v2",
  },
  {
    value: "odm",
    label: "ODM",
    url: "/subscription/one_day_membership_lead/all",
  },
  {
    value: "wati",
    label: "Wati",
    url: "/leads/unassigned",
  },
  {
    value: "recurring",
    label: "Recurring 999",
    url: "/subscription/tripple-nine",
  },
  {
    value: "walkins",
    label: "Walkin",
    url: "/leads/walkin",
  },
  {
    value: "unpaid_members",
    label: "Unpaid Members",
    url: "/gym/dashboard/reports/details/v2",
  },
  {
    value: "renewal_members",
    label: "Renewal Members",
    url: "/gym/dashboard/reports/details/v2",
  },
];

export const broadcast_logs_status = [
  {
    label: "Success",
    value: "sent",
  },
  {
    label: "Failed",
    value: "failed",
  },
  {
    label: "Pending",
    value: "pending",
  },
];

export const new_existing_member = [
  {
    value: "true",
    label: "New Member",
  },
  {
    value: "false",
    label: "Existing Member",
  },
];

export const bca_scheduler_condition = [
  {
    value: "completed",
    label: "Completed",
  },
  {
    value: "upcoming",
    label: "Upcoming",
  },
  {
    value: "missed",
    label: "Missed",
  },
];

export const scheduler_types = [
  {
    value: "bca",
    label: "BCA",
  },
  {
    value: "fitness_profile",
    label: "Fitness Profile",
  },
];

export const segment_types = [
  {
    value: "Renewal",
    label: "Renewal",
  },
  {
    value: "Unpaid",
    label: "Unpaid",
  },
  {
    value: "cart_abandoned",
    label: "Cart Abandoned",
  },
];

export const three_day_pt_trial_session_status = [
  {
    value: "0",
    label: "0",
  },
  {
    value: "1",
    label: "1",
  },
  {
    value: "2",
    label: "2",
  },
  {
    value: "3",
    label: "3",
  },
];

export const three_day_assigned = [
  {
    value: "0",
    label: "Not Assigned",
  },
  {
    value: "1",
    label: "Assigned",
  },
];

export const three_day_day_no = [
  {
    value: "day_1",
    label: "Day 1",
  },
  {
    value: "day_2",
    label: "Day 2",
  },
  {
    value: "day_3",
    label: "Day 3",
  },
];

export const three_day_completed_count = [
  {
    value: "0",
    label: "0 Sessions",
  },
  {
    value: "1",
    label: "1 Session",
  },
  {
    value: "2",
    label: "2 Sessions",
  },
  {
    value: "3",
    label: "3 Sessions",
  },
];

export const three_day_slot_time = [
  {
    value: "06:00-07:00",
    label: "06:00 AM - 07:00 AM",
  },
  {
    value: "07:00-08:00",
    label: "07:00 AM - 08:00 AM",
  },
  {
    value: "08:00-09:00",
    label: "08:00 AM - 09:00 AM",
  },
  {
    value: "09:00-10:00",
    label: "09:00 AM - 10:00 AM",
  },
  {
    value: "10:00-11:00",
    label: "10:00 AM - 11:00 AM",
  },
  {
    value: "11:00-12:00",
    label: "11:00 AM - 12:00 PM",
  },
  {
    value: "12:00-13:00",
    label: "12:00 PM - 01:00 PM",
  },
  {
    value: "13:00-14:00",
    label: "01:00 PM - 02:00 PM",
  },
  {
    value: "14:00-15:00",
    label: "02:00 PM - 03:00 PM",
  },
  {
    value: "15:00-16:00",
    label: "03:00 PM - 04:00 PM",
  },
  {
    value: "16:00-17:00",
    label: "04:00 PM - 05:00 PM",
  },
  {
    value: "17:00-18:00",
    label: "05:00 PM - 06:00 PM",
  },
  {
    value: "18:00-19:00",
    label: "06:00 PM - 07:00 PM",
  },
  {
    value: "19:00-20:00",
    label: "07:00 PM - 08:00 PM",
  },
  {
    value: "20:00-21:00",
    label: "08:00 PM - 09:00 PM",
  },
  {
    value: "21:00-22:00",
    label: "09:00 PM - 10:00 PM",
  },
];

export const pre_gym_sales = [
  {
    value: "all",
    label: "All (Pre & Regular & Sales)",
  },
  {
    value: "1",
    label: "Only Pre Gym Sales",
  },
  {
    value: "0",
    label: "Only Regular Gym Sales",
  },
];

export const email_statuses = [
  {
    value: "true",
    label: "Sent",
  },
  {
    value: "false",
    label: "Not Sent",
  },
];

export const lead_stage = [
  {
    value: "fresh",
    label: "Fresh",
  },
  {
    value: "renewal",
    label: "Renewal",
  },
  {
    value: "unpaid",
    label: "Unpaid",
  },
  {
    value: "subscribed",
    label: "Subscribed",
  },
];

export const wati_accounts = [
  {
    label: "WTF Agents Marketing",
    value: "wtf_agents_marketing",
  },
  {
    label: "WTF Gyms Offer",
    value: "wtf_gyms_offer",
  },
];

export const price_ranges = [
  {
    value: "0",
    label: "0",
  },
  {
    value: "10000",
    label: "10,000",
  },
  {
    value: "20000",
    label: "20,000",
  },
  {
    value: "30000",
    label: "30,000",
  },
  {
    value: "40000",
    label: "40,000",
  },
  {
    value: "50000",
    label: "50,000",
  },
  {
    value: "60000",
    label: "60,000",
  },
  {
    value: "70000",
    label: "70,000",
  },
  {
    value: "80000",
    label: "80,000",
  },
  {
    value: "90000",
    label: "90,000",
  },
  {
    value: "100000",
    label: "1,00,000",
  },
];

export const roaster_status = [
  {
    label: "Scheduled",
    value: "scheduled",
  },
  {
    label: "Completed",
    value: "completed",
  },
];

export const weekoff_status = [
  {
    label: "On Leave",
    value: "leave",
  },
  {
    label: "Day Off",
    value: "dayoff",
  },
];

export const odm_lead_from = [
  {
    value: "campaign",
    label: "Campaign",
  },
  {
    value: "website",
    label: "Website",
  },
];

// Live Subscription specific dropdown data
export const liveSubscriptionMembershipTypes = [
  { label: "All Types", value: "all" },
  { label: "Platinum", value: "Platinum" },
  { label: "Gold", value: "Gold" },
  { label: "Silver", value: "Silver" },
  { label: "Bronze", value: "Bronze" },
  { label: "Trial", value: "Trial" },
];

export const liveSubscriptionStatuses = [
  { label: "All Status", value: "all" },
  { label: "Pending", value: "pending" },
  { label: "Processing", value: "processing" },
  { label: "Completed", value: "completed" },
  { label: "Failed", value: "failed" },
];

export const liveSubscriptionPriorities = [
  { label: "All Priority", value: "all" },
  { label: "Critical", value: "critical" },
  { label: "Warning", value: "warning" },
  { label: "Normal", value: "normal" },
];

export const liveSubscriptionDateRanges = [
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "Last 7 Days", value: "last7days" },
  { label: "Last 30 Days", value: "last30days" },
  { label: "This Month", value: "thisMonth" },
];

export const resolution_status = [
  {
    label: "Resolved",
    value: "1",
  },
  {
    label: "Not Resolved",
    value: "0",
  },
];

export const regularization_approval_status = [
  {
    label: "Approved",
    value: "approved",
  },
  {
    label: "Rejected",
    value: "rejected",
  },
  {
    label: "HR Approval Pending",
    value: "hr_pending",
  },
  {
    label: "Manager Approval Pending",
    value: "manager_pending",
  },
];

export const tme_analysis_attendance_checkin_status = [
  {
    label: "Trainer Present",
    value: "trainer_present",
  },
  {
    label: "Member Present",
    value: "member_present",
  },
  {
    label: "Both Present",
    value: "both_present",
  },
  {
    label: "Both Absent",
    value: "both_absent",
  },
];

export const hygiene_task_review = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "pending",
    label: "In Progress",
  },
  {
    value: "missed",
    label: "Missed Tasks",
  },
  {
    value: "upcoming",
    label: "Upcoming Tasks",
  },
  {
    value: "completed",
    label: "Task Done",
  },
  {
    value: "approved",
    label: "Approved By Admin",
  },
  {
    value: "rejected",
    label: "Rejected By Admin",
  },
  {
    value: "all_rejected",
    label: "All Rejected (All Time) By Admin",
  },
  {
    value: "re_submitted",
    label: "Re-submitted",
  },
];

export const required_not_required_statuses = [
  {
    value: "1",
    label: "Required",
  },
  {
    value: "0",
    label: "Not Required",
  },
];

export const wtf_360_consultation_statuses = [
  {
    value: "pending",
    label: "Pending",
  },
  {
    value: "contacted",
    label: "Contacted",
  },
  {
    value: "scheduled",
    label: "Scheduled",
  },
  {
    value: "completed",
    label: "Completed",
  },
  {
    value: "cancelled",
    label: "Cancelled",
  },
];

export const trainer_notification_log_statuses = [
  {
    value: "sent",
    label: "Sent",
  },
  {
    value: "failed",
    label: "Failed",
  },
  {
    value: "pending",
    label: "Pending",
  },
];

export const trainer_bca_evaluation_filter_types = [
  {
    value: "assigned_members",
    label: "Assigned Members",
  },
  {
    value: "bca_pending",
    label: "BCA Pending",
  },
  {
    value: "first_bca_pending",
    label: "First BCA Pending",
  },
  {
    value: "recurring_bca_pending",
    label: "Recurring BCA Pending",
  },
  {
    value: "bca_completed",
    label: "BCA Completed",
  },
  {
    value: "fitness_profile_completed",
    label: "Fitness Profile Completed",
  },
  {
    value: "three_day_assigned",
    label: "Three Day Assigned",
  },
  {
    value: "three_day_completed",
    label: "Three Day Completed",
  },
  {
    value: "day1",
    label: "Day 1",
  },
  {
    value: "day2",
    label: "Day 2",
  },
  {
    value: "day3",
    label: "Day 3",
  },
  {
    value: "pt_prospect",
    label: "PT Prospect",
  },
  {
    value: "pt_converted",
    label: "PT Converted",
  },
];

export const fresh_existing = [
  {
    value: "0",
    label: "Fresh Member",
  },
  {
    value: "1",
    label: "Existing Member",
  },
];

export const stuck_status = [
  {
    value: "0",
    label: "Not Stuck",
  },
  {
    value: "1",
    label: "Stuck",
  },
];

export const visit_scheduled_options = [
  {
    value: "1",
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <CheckCircleIcon /> Visit Scheduled
      </span>
    ),
  },
  {
    value: "0",
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <XCircleIcon /> Visit Not Scheduled
      </span>
    ),
  },
];

export const visit_done_options = [
  {
    value: "1",
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <CheckCircleIcon /> Visit Done
      </span>
    ),
  },
  {
    value: "0",
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <XCircleIcon /> Visit Not Done
      </span>
    ),
  },
];

export const pt_trial_status = [
  {
    value: "1",
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <CheckCircleIcon /> Started
      </span>
    ),
  },
  {
    value: "0",
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <XCircleIcon /> Not Started
      </span>
    ),
  },
];

export const active_deleted = [
  {
    value: "0",
    label: "Active",
  },
  {
    value: "1",
    label: "Deleted",
  },
];

export const wap_sent_status = [
  {
    value: "1",
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <CheckCircleIcon /> Sent
      </span>
    ),
  },
  {
    value: "0",
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <XCircleIcon /> Not Sent
      </span>
    ),
  },
];

export const wap_delivered_status = [
  {
    value: "1",
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <CheckCircleIcon /> Delivered
      </span>
    ),
  },
  {
    value: "0",
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <XCircleIcon /> Not Delivered
      </span>
    ),
  },
];

export const wap_read_status = [
  {
    value: "1",
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <CheckCircleIcon /> Read
      </span>
    ),
  },
  {
    value: "0",
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <XCircleIcon /> Not Read
      </span>
    ),
  },
];
